import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { cls, getContourColor, keyHash } from '@mssgme/helpers';
import { Button } from '@mssgme/ui';

import styles from './ThemedButton.scss';

export const ThemedButton = ({ theme, isFetching, disabled, contour, style: baseStyle, contentAlignLeft, ...rest }) => {
    const style = useMemo(() => {
        if (contour) {
            const { backgroundColor, color, border } = getContourColor(
                theme.backgroundColor,
                theme.buttonBackground,
                theme.buttonTextColor
            );

            return {
                backgroundColor,
                color,
                border: `1px solid ${border}`,
                ...baseStyle,
            };
        }

        return {
            backgroundColor: theme.buttonBackground,
            color: theme.buttonTextColor,
            ...baseStyle,
        };
    }, [contour, theme, keyHash(baseStyle)]);

    return (
        <Button
            tag="a"
            size="standart"
            isFetching={isFetching}
            disabled={disabled}
            style={style}
            loaderColor={style.color}
            {...cls([styles.root, contentAlignLeft && styles.contentAlignLeft], rest)}
        />
    );
};

ThemedButton.propTypes = {
    ...Button.propTypes,
    theme: PropTypes.object.isRequired,
    contour: PropTypes.bool,
    contentAlignLeft: PropTypes.bool,
};
